import styled, { css } from 'styled-components';
import { white, black, maroon, primary, mediumGrey } from 'constants/color';

export const StyledCaption = styled.h1`
  margin: 5px 0;
  color: ${black};
`;

export const StyledSubHeading = styled.h6`
  margin: 1px 0 5px 0;
  color: ${primary};
`;

export const StyledSubHeader = styled.p`
  margin: 0;
  padding: 0;
  font-size: 10px;
  font-weight: 600;
`;

export const StyledInputButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  visibility: hidden;
  color: ${mediumGrey};
  &:disabled {
    cursor: not-allowed;
  }
  &:hover {
    color: ${white};
    background-color: ${primary};
  }
`;

export const StyledInput = styled.input`
  color: #000;
  border: none;
  cursor: text;
  outline: none;
  font-size: 12px;
  font-weight: normal;
  box-sizing: border-box;
  border-bottom: 1px solid ${mediumGrey};
  &[type='number'] {
    width: 40px;
    text-align: center;
  }
  &:read-only {
    border-bottom: none;
    background-color: transparent;
  }
  &:focus {
    ${function ({ $unsaved }) {
      return (
        $unsaved &&
        css`
          border-bottom: 1px solid ${primary};
        `
      );
    }}
    &[name]:not([name='sku']) {
      border-bottom: 1px solid ${primary};
    }
  }
  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }
`;

export const StyledInputWrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 400px;
  ${function ({ $active }) {
    return (
      $active &&
      css`
        &:hover {
          ${StyledInputButton} {
            color: ${white};
            visibility: visible;
            background-color: ${primary};
          }
          ${StyledInput} {
            border-top: 1px solid ${primary};
            border-left: 1px solid ${primary};
            border-bottom: 1px solid ${primary};
          }
        }
      `
    );
  }}
`;

export const StyledTableRow = styled.tr`
  ${function ({ $sub }) {
    return (
      !$sub &&
      css`
        &:not(:first-child) {
          & td {
            border-top: 1px solid ${primary};
          }
        }
      `
    );
  }}
  &:last-child {
    & td {
      border-bottom: 1px solid ${primary};
    }
  }
`;

export const StyledRoundButton = styled.button`
  width: 20px;
  height: 20px;
  border: none;
  color: white;
  display: flex;
  cursor: pointer;
  font-size: 20px;
  border-radius: 50%;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: ${function (p) {
    return p.$minus ? mediumGrey : primary;
  }};
`;

export const StyledQuantityWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledRowButton = styled.button`
  border: none;
  display: flex;
  cursor: pointer;
  font-size: 15px;
  color: ${primary};
  text-align: center;
  font-weight: normal;
  align-items: center;
  background-color: white;
  justify-content: center;
`;

export const StyledRoundIcon = styled.span`
  width: 20px;
  height: 20px;
  border: none;
  color: white;
  display: flex;
  cursor: pointer;
  font-size: 20px;
  border-radius: 50%;
  margin-right: 10px;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: ${primary};
`;

export const StyledErrorMessage = styled.p`
  color: ${maroon};
  font-size: 12px;
  font-weight: 400;
  margin: 2px 0 0 0;

  ${function (p) {
    return (
      p.$main &&
      css`
        font-size: 14px;
        padding: 5px 10px;
        margin: 5px 0 10px 5px;
        background-color: #f8d7da;
      `
    );
  }}
`;

export const StyledButtonWrapper = styled.div`
  width: 20%;
  min-height: 1px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
  }
  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;

export const StyledTableWrapper = styled.div`
  ${function (p) {
    return (
      p.$isUpdatingQuantity &&
      css`
        height: 430px;
        overflow-y: auto;
        padding-right: 15px;
      `
    );
  }}
  ${({ theme }) => theme.scrollbar};
  /* Mobile Devices */
  @media (max-width: 480px) {
    overflow-x: auto;
  }
`;

export const StyledWrapper = styled.div`
  /* Mobile Devices */
  @media (max-width: 480px) {
    overflow: hidden;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  svg {
    fill: ${({ theme }) => theme.primaryColor};
  }
`;
